"use client";

import { useEffect, useState } from "react";
import { motion } from "framer-motion";
// import Image from "next/image";
import {
  ChevronRight,
  User,
  CreditCard,
  LineChart,
  BarChart4,
} from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import agregarcuenta from "../../assets/agregarcuenta.png";
import agregartransaccion from "../../assets/agregartransaccion.png";
import agregarreporte from "../../assets/agregarreporte.png";
import agregarinforme from "../../assets/agregarinforme.png";
const steps = [
  {
    id: "create",
    title: "Crea tus cuentas bancarias",
    description:
      "Regístrate fácilmente y configura tu perfil en menos de 2 minutos.",
    icon: User,
    image: agregarcuenta,
  },
  {
    id: "connect",
    title: "Registra tus transacciones",
    description: "Añade tus ingresos, egresos e inversiones.",
    icon: CreditCard,
    image: agregartransaccion,
  },
  {
    id: "track",
    title: "Seguimiento automático",
    description:
      "Centraliza tus transacciones en un solo lugar para un control sin esfuerzo.",
    icon: LineChart,
    image: agregarreporte,
  },
  {
    id: "analyze",
    title: "Analiza y optimiza",
    description:
      "Obtén informes personalizados y recomendaciones para mejorar tu salud financiera.",
    icon: BarChart4,
    image: agregarinforme,
  },
];

export default function HowItWorks() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  return (
    <section id="funcionamiento" className="py-20 relative">
      {/* Background gradient effect */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-chart-3/10 rounded-full blur-3xl dark:bg-chart-3/5" />

      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            <span className="bg-gradient-to-r from-chart-2 to-chart-3 text-transparent bg-clip-text">
              Cómo funciona
            </span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Simplificamos la gestión financiera para que puedas enfocarte en
            hacer crecer tu negocio.
          </p>
        </motion.div>

        <Tabs defaultValue="create" className="w-full">
          <div className="flex flex-col md:flex-row gap-10 lg:gap-20">
            <div className="w-full md:w-1/3">
              <TabsList className="flex flex-col w-full h-auto bg-transparent space-y-2">
                {steps.map((step, index) => (
                  <TabsTrigger
                    key={step.id}
                    value={step.id}
                    className="w-full flex items-start gap-4 p-4 data-[state=active]:bg-muted data-[state=active]:shadow-sm justify-start rounded-lg border border-transparent data-[state=active]:border-border"
                  >
                    <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-full bg-gradient-to-br from-chart-1/20 to-chart-2/20 data-[state=active]:from-chart-1/30 data-[state=active]:to-chart-2/30">
                      <step.icon className="h-5 w-5 text-chart-1" />
                    </div>
                    <div className="text-left w-90">
                      <div className="flex items-center">
                        <span className="text-sm text-muted-foreground mr-2 font-bold">
                          {index + 1}.
                        </span>
                        <h3 className="font-bold">{step.title}</h3>
                      </div>
                      <p className="whitespace-normal text-sm text-muted-foreground mt-1">
                        {step.description}
                      </p>
                    </div>
                  </TabsTrigger>
                ))}
              </TabsList>
            </div>

            <div className="w-full md:w-2/3">
              {steps.map((step) => (
                <TabsContent
                  key={step.id}
                  value={step.id}
                  className="mt-0 focus-visible:outline-none focus-visible:ring-0"
                >
                  <motion.div
                    initial={{ opacity: 0, scale: 0.95 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.3 }}
                    className="relative"
                  >
                    <Card className="border-muted/40 bg-card/50 backdrop-blur overflow-hidden">
                      <CardContent className="p-1">
                        <div className="relative w-full h-[auto] sm:h-[auto] rounded-lg overflow-hidden">
                          <img
                            src={step.image}
                            alt={step.title}
                            cover
                            className="object-cover"
                          />
                        </div>
                      </CardContent>
                    </Card>
                  </motion.div>
                </TabsContent>
              ))}
            </div>
          </div>
        </Tabs>
      </div>
    </section>
  );
}
